import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { NAV_ITEMS, API_BASE_URL } from "./constants/adminConstants";
import "./css/adminStyles.css";

function AdminMobileNav({ user }) {
  const [open, setOpen] = useState(false);
  const [expandedParents, setExpandedParents] = useState(new Set());
  const navigate = useNavigate();

  if (!user) return null;

  const navItems = (NAV_ITEMS[user.role] || []).filter(
    (item) => item.label !== "Notifications"
  );

  const handleNavigate = (path) => {
    setOpen(false);
    const cleanPath = path.startsWith("/") ? path.slice(1) : path;
    navigate(`/${cleanPath}`);
  };

  const handleLogout = async () => {
    setOpen(false);
    const token = sessionStorage.getItem("tvc_token");
    if (token) {
      try {
        await fetch(`${API_BASE_URL}/auth/logout`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
        });
      } catch {}
    }
    sessionStorage.removeItem("tvc_token");
    sessionStorage.removeItem("tvc_user");
    navigate("../login");
  };

  const toggleParent = (path) => {
    setExpandedParents((prev) => {
      const next = new Set(prev);
      if (next.has(path)) next.delete(path);
      else next.add(path);
      return next;
    });
  };

  const isActiveOrChildActive = (item, currentPath) => {
    if (item.path === currentPath) return true;
    if (item.children) {
      return item.children.some((c) => c.path === currentPath || (c.children && c.children.some((gc) => gc.path === currentPath)));
    }
    return false;
  };

  const renderNavItem = (item, depth = 0) => {
    const currentPath = window.location.pathname;
    if (item.children) {
      const isExpanded = expandedParents.has(item.path);
      const hasActive = isActiveOrChildActive(item, currentPath);
      return (
        <div key={item.path} className="AdminNavGroup">
          <div className={`AdminNavItem AdminNavParent ${hasActive ? "AdminNavItemActive" : ""}`}>
            <button
              className="AdminNavParentBtn"
              onClick={() => { toggleParent(item.path); handleNavigate(item.path); }}
            >
              {item.label}
            </button>
            <span
              className={`AdminNavExpandIcon ${isExpanded ? "AdminNavExpandIconOpen" : ""}`}
              onClick={() => toggleParent(item.path)}
            >
              &#9654;
            </span>
          </div>
          <div className={`AdminNavChildren ${isExpanded ? "AdminNavChildrenOpen" : ""}`}>
            {item.children.map((child) => renderNavItem(child, depth + 1))}
          </div>
        </div>
      );
    }
    return (
      <button
        key={item.path}
        className={`AdminNavItem ${depth > 0 ? "AdminNavChild" : ""} ${currentPath === item.path ? "AdminNavItemActive" : ""}`}
        style={depth > 0 ? { paddingLeft: 24 + (depth - 1) * 12 } : {}}
        onClick={() => handleNavigate(item.path)}
      >
        {item.label}
      </button>
    );
  };

  return (
    <div className="AdminMobileNavWrap">
      <button
        className="AdminMobileNavToggle"
        onClick={() => setOpen(!open)}
        title="Menu"
      >
        {open ? "\u2715" : "\u2630"}
      </button>
      {open && (
        <>
          <div className="AdminMobileNavOverlay" onClick={() => setOpen(false)} />
          <div className="AdminMobileNavDropdown">
            <div className="AdminMobileNavUser">
              <div className="AdminSidebarAvatar" title={`${user.firstName} ${user.lastName}`}>{user.firstName?.[0]}{user.lastName?.[0]}</div>
              <div className="AdminMobileNavUserInfo">
                <span className="AdminMobileNavUserName">{user.firstName} {user.lastName}</span>
                <span className="AdminMobileNavUserId">{user.loginId}</span>
              </div>
            </div>
            <nav className="AdminMobileNavBody">
              {navItems.map((item) => renderNavItem(item))}
            </nav>
            <button className="AdminMobileNavLogout" onClick={handleLogout}>
              Sign Out
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default AdminMobileNav;
